import layout1 from "../../assets/images/layout/grid_01.svg";
import layout2 from "../../assets/images/layout/grid_02.svg";
import layout3 from "../../assets/images/layout/grid_03.svg";
import layout4 from "../../assets/images/layout/grid_04.svg";
import layout5 from "../../assets/images/layout/grid_05.svg";
import layout6 from "../../assets/images/layout/grid_06.svg";
import layout7 from "../../assets/images/layout/grid_07.svg";
import { BlockType } from "../models";

export enum LayoutTemplates {
    Layout1 = 0,
    Layout2 = 1,
    Layout3 = 2,
    Layout4 = 3,
    Layout5 = 4,
    Layout6 = 5,
    Layout7 = 6,
}

// Map templateId to images
export const LayoutImages: Record<number, string> = {
    [LayoutTemplates.Layout1]: layout1,
    [LayoutTemplates.Layout2]: layout2,
    [LayoutTemplates.Layout3]: layout3,
    [LayoutTemplates.Layout4]: layout4,
    [LayoutTemplates.Layout5]: layout5,
    [LayoutTemplates.Layout6]: layout6,
    [LayoutTemplates.Layout7]: layout7,
};

// Fallback if templateId doesn't match
export const getLayoutImage = (templateId?: number): string => {
    return LayoutImages[templateId ?? LayoutTemplates.Layout1] || layout1;
};

// Block Layout Configurations
export const BlockLayoutSupport: Record<number, number[]> = {
    [BlockType.GENERAL_VOD]: [
        LayoutTemplates.Layout1,
        LayoutTemplates.Layout2,
        LayoutTemplates.Layout3,
        LayoutTemplates.Layout4,
        LayoutTemplates.Layout5,
        LayoutTemplates.Layout6,
        LayoutTemplates.Layout7
    ],
    [BlockType.FILM_FESTIVAL_VOD]: [
        LayoutTemplates.Layout1,
        LayoutTemplates.Layout2,
        LayoutTemplates.Layout3,
        LayoutTemplates.Layout4,
        LayoutTemplates.Layout5,
        LayoutTemplates.Layout6,
        LayoutTemplates.Layout7
    ],
    [BlockType.LIVE_STREAMS]: [
        LayoutTemplates.Layout1,
        LayoutTemplates.Layout2,
        LayoutTemplates.Layout3,
        LayoutTemplates.Layout4,
        LayoutTemplates.Layout5,
    ],
    [BlockType.PLAYLIST]: [
        LayoutTemplates.Layout1,
        LayoutTemplates.Layout2,
        LayoutTemplates.Layout3,
        LayoutTemplates.Layout4,
        LayoutTemplates.Layout5,
        LayoutTemplates.Layout6,
        LayoutTemplates.Layout7
    ],
}